module.exports = "/_next/static/chunks/images/person-at-laptop-1dbf682afd3a9bbc5478d529cc0add2f.jpg";